import { ref, computed } from 'vue';

const STORAGE_KEY = 'theme';
const THEMES = ['dark', 'light'];

const readStoredTheme = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return THEMES.includes(stored) ? stored : null;
    } catch (error) {
        return null; // localStorage can be unavailable (private mode, blocked storage)
    }
};

const systemTheme = () => {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
};

const applyTheme = (value) => {
    document.documentElement.setAttribute('data-theme', value);
};

// Shared by every component: an explicit choice (saved in localStorage) wins,
// otherwise the operating system preference is used.
const theme = ref(readStoredTheme() || systemTheme());
applyTheme(theme.value);

if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', () => {
        if (!readStoredTheme()) {
            theme.value = systemTheme();
            applyTheme(theme.value);
        }
    });
}

export function useTheme() {
    const isDark = computed(() => theme.value === 'dark');

    const setTheme = (value) => {
        theme.value = value;
        applyTheme(value);
        try {
            localStorage.setItem(STORAGE_KEY, value);
        } catch (error) {
            // the choice still applies for this visit
        }
    };

    const toggleTheme = () => {
        setTheme(isDark.value ? 'light' : 'dark');
    };

    return { theme, isDark, setTheme, toggleTheme };
}
